import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateAnObjectSkillType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ObjectSkillType/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetObjectSkillTypesOfProduct extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ObjectSkillType/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteObjectSkillType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ObjectSkillType/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateAnObjectSkillType,
  GetObjectSkillTypesOfProduct,
  DeleteObjectSkillType,
};
